var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetItOnGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310 120",
    width: 310,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GetItOnGooglePlay_Badge_Web_color_English-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: 0;fill: #ffffff } \n\t\t.s1 { fill: #000000 } \n\t\t.s2 { fill: #a6a6a6 } \n\t\t.s3 { fill: #ffffff;stroke: #ffffff;stroke-miterlimit:10;stroke-width: .4 } \n\t\t.s4 { fill: #ffffff } \n\t\t.s5 { fill: #ea4335 } \n\t\t.s6 { fill: #fbbc04 } \n\t\t.s7 { fill: #4285f4 } \n\t\t.s8 { fill: #34a853 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m310 120h-310v-120h310z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m280 100h-250c-5.5 0-10-4.5-10-10v-60c0-5.5 4.5-10 10-10h250c5.5 0 10 4.5 10 10v60c0 5.5-4.5 10-10 10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m290 30v60c0 5.5-4.5 10-10 10h-250c-5.5 0-10-4.5-10-10v-60c0-5.5 4.5-10 10-10h250c5.5 0 10 4.5 10 10zm-260-8.4c-4.6 0-8.4 3.8-8.4 8.4v60c0 4.6 3.8 8.4 8.4 8.4h250c4.6 0 8.4-3.8 8.4-8.4v-60c0-4.6-3.8-8.4-8.4-8.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m114.8 40.5q0 2.5-1.5 4-1.6 1.8-4.4 1.8-2.6 0-4.4-1.8-1.8-1.8-1.8-4.5 0-2.7 1.8-4.5 1.8-1.8 4.4-1.8 1.3 0 2.5 0.5 1.2 0.5 1.9 1.4l-1.1 1q-1.2-1.4-3.3-1.4-1.9 0-3.2 1.3-1.4 1.4-1.4 3.5 0 2.1 1.4 3.5 1.3 1.3 3.2 1.3 2 0 3.4-1.3 0.9-0.9 1-2.5h-4.4v-1.4h5.9q0 0.5 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m124.1 35.5h-5.5v3.8h4.9v1.4h-4.9v3.8h5.5v1.5h-7.1v-12h7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m130.6 46h-1.6v-10.5h-3.3v-1.5h8.2v1.5h-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m139.9 46v-12h1.5v12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m148.3 46h-1.6v-10.5h-3.3v-1.5h8.2v1.5h-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m167.2 44.4q-1.8 1.9-4.4 1.9-2.6 0-4.4-1.9-1.7-1.8-1.7-4.4 0-2.6 1.7-4.4 1.8-1.9 4.4-1.9 2.6 0 4.4 1.9 1.8 1.8 1.8 4.4 0 2.6-1.8 4.4zm-7.6-1q1.3 1.4 3.2 1.4 1.9 0 3.3-1.4 1.3-1.3 1.3-3.4 0-2.1-1.3-3.4-1.4-1.4-3.3-1.4-1.9 0-3.2 1.4-1.4 1.3-1.4 3.4 0 2.1 1.4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m171.2 46v-12h1.8l5.9 9.3v-2.3-7h1.5v12h-1.6l-6.1-9.8h-0.1l0.1 2.3v7.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m164.8 72c0 4.9-3.8 8.5-8.5 8.5-4.7 0-8.6-3.6-8.6-8.5 0-4.9 3.9-8.5 8.6-8.5 4.7 0 8.5 3.6 8.5 8.5zm-3.7 0c0-3.1-2.3-5.1-4.8-5.1-2.6 0-4.8 2-4.8 5.1 0 3 2.2 5.2 4.8 5.2 2.5 0 4.8-2.2 4.8-5.2zm-14.9 0c0 4.9-3.9 8.5-8.6 8.5-4.7 0-8.5-3.6-8.5-8.5 0-4.9 3.8-8.5 8.5-8.5 4.7 0 8.6 3.6 8.6 8.5zm-3.8 0c0-3.1-2.2-5.1-4.8-5.1-2.5 0-4.8 2-4.8 5.1 0 3 2.3 5.2 4.8 5.2 2.6 0 4.8-2.2 4.8-5.2zm-14.8-5.9c0.2 0.7 0.2 1.4 0.2 2.3 0 2.7-0.7 6-3.1 8.4-2.3 2.4-5.3 3.7-9.2 3.7-7.3 0-13.4-5.9-13.4-13.2 0-7.3 6.1-13.2 13.4-13.2 4 0 6.9 1.6 9 3.6l-2.5 2.6c-1.6-1.5-3.6-2.6-6.5-2.6-5.3 0-9.5 4.3-9.5 9.6 0 5.3 4.2 9.6 9.5 9.6 3.4 0 5.4-1.4 6.7-2.6 1-1.1 1.7-2.5 1.9-4.6h-8.6v-3.6zm78.8 3.8l-11.3 4.7c0.8 1.7 2.2 2.6 4.1 2.6 1.9 0 3.2-1 4.2-2.4l2.9 1.9c-1 1.4-3.2 3.8-7.1 3.8-4.8 0-8.4-3.7-8.4-8.5 0-5 3.6-8.5 8-8.5 4.4 0 6.5 3.5 7.3 5.4zm-4.4-1.3c-0.4-1-1.7-1.8-3.2-1.8-1.9 0-4.5 1.7-4.4 5zm-16.9-13.6h3.8v25h-3.8zm-6.1 9h3.5v15.3c0 6.3-3.7 8.8-8 8.8-4.2 0-6.7-2.7-7.6-5l3.3-1.3c0.5 1.4 2 3 4.3 3 2.8 0 4.5-1.7 4.5-5v-1.2h-0.1c-0.9 1-2.5 1.9-4.5 1.9-4.3 0-8.2-3.7-8.2-8.5 0-4.8 3.9-8.5 8.2-8.5 2 0 3.6 0.9 4.5 1.9h0.1zm0.3 8c0-3-2-5.2-4.6-5.2-2.6 0-4.7 2.2-4.7 5.2 0 3 2.1 5.1 4.7 5.1 2.6 0 4.6-2.1 4.6-5.1zm52.4-9.3c0 4.8-4.1 7.8-8.2 7.8h-5.2v9.5h-3.8v-25h9c4.1 0 8.2 3 8.2 7.7zm-3.8 0c0-1.9-1.5-4.2-4.3-4.2h-5.3v8.5h5.3c2.8 0 4.3-2.3 4.3-4.3zm26.3 7.7v9.5h-3.6v-1.9h-0.1c-0.9 1.3-2.3 2.5-4.8 2.5-3.2 0-6.2-2.2-6.2-5.5 0-3.7 3.7-5.7 7.2-5.7 1.8 0 3.2 0.6 3.9 1v-0.3c0-2-2-3.2-3.9-3.2-1.4 0-2.7 0.5-3.4 1.8l-3.3-1.3c1.1-2.7 3.9-3.9 6.6-3.9 4.3 0 7.6 2.5 7.6 7zm-3.6 2.8c-1-0.5-1.7-0.9-3.4-0.9-1.8 0-3.9 0.8-3.9 2.7 0 1.5 1.7 2.1 2.9 2.1 2.1 0 4.1-1.6 4.4-3.9zm20.9-9.2l-10.3 23.6h-3.9l3.8-8.5-6.6-15.1h4l4.4 10.8h0.2l4.2-10.8zm-37.7-9h3.7v25h-3.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m61.4 58.8l-21.3 22.6q0 0.1 0 0.1c0.7 2.4 2.9 4.2 5.6 4.2 1.1 0 2.1-0.3 2.9-0.8h0.1l24-13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m83 55l-10.4-6-11.6 10.4 11.6 11.7 10.3-6c1.8-1 3.1-2.9 3.1-5.1 0-2.1-1.2-4-3-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m40.1 38.6q-0.2 0.7-0.2 1.4v40q0 0.7 0.2 1.4l22.1-22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m61.6 60l11-11-23.9-13.9c-0.9-0.5-1.9-0.8-3-0.8-2.7 0-4.9 1.8-5.6 4.2q0 0.1 0 0.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetItOnGooglePlayBadge);
export default __webpack_public_path__ + "static/media/GetItOnGooglePlay_Badge.ccaebb175d778a06b5b078f175bbe98d.svg";
export { ForwardRef as ReactComponent };